import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { accountInitialValues } from 'components/organisms/forms/account/AccountForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostAccount } from 'services/accounts';
import { IAccountMutationForm } from 'services/accounts/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateAccount = () => {
  const createAccount = usePostAccount();

  const { t } = useTranslation();

  const navigate = useNavigate();

  const mutateOptions = useMutateOptions<IAccountMutationForm>();

  const goToDetail = (id: string) => navigate(`/account/${id}/finances`);

  const onCreateAccount = async (
    values: IAccountMutationForm,
    helpers: FormikHelpers<IAccountMutationForm>
  ) => {
    const { apiEndpoint, ...account } =
      middleware.account.formToAccountQuery(values);
    const licence = middleware.account.formToLicenceQuery(values);

    await createAccount.mutateAsync(
      {
        ...account,
        endpoint: apiEndpoint,
        license: values.withLicense ? licence.license : null,
      },
      {
        ...mutateOptions(helpers),
        onSuccess: data => {
          goToDetail(data.id);
        },
      }
    );
  };

  return (
    <Form.Accounts
      i18nextPrefix='account'
      initialValues={accountInitialValues}
      onSubmit={onCreateAccount}
      customBackItem={
        <Button onlyIcon onClick={() => navigate('/account')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
        </Button>
      }
    />
  );
};

export default CreateAccount;
